<script lang="ts" setup>

</script>

<template>
  <button class="btn-base btn-default">
    <slot></slot>
  </button>
</template>

<style scoped>
.btn-default {
  display: flex;
  align-items: center;
  /* Vertically center icon and text */
  justify-content: center;
  /* Horizontally center content */
  gap: 6px;
  cursor: pointer;
  outline: 0;
  background-color: #ffffff;
  box-sizing: border-box;
  height: 36px;
  border: 1px solid #E2E3E6;
  border-radius: 0;
  vertical-align: middle;
  background-repeat: no-repeat;
  background-position-x: center;
  background-position-y: center;
  color: #000;
  font-size: 14px;
  font-weight: 500;
  padding-left: 18px;
  padding-right: 18px;

  &:hover {
    background-color: #008800;
    color: #fff;
  }
}
</style>